import ContextNames from './context_names';

/**
 * Creates a basic action class for canceling entity edit
 * @param EntityClass - the class of entity being canceled
 * @returns a class for entity edit cancellation action
 */
export default function createCancelAction(EntityClass) {
  var { storeName } = ContextNames.fromModelClass(EntityClass);

  return class {
    constructor(context) {
      this.context = context;
    }

    run(id) {
      if (id) {
        this.context.stores[storeName].clearErrors(id);
      } else {
        this.context.stores[storeName].clearErrorsForNew();
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/lib/create_cancel_action.js